export const CARD_SIMPLE_CONSTANTS = {
    DEFAULT_IMAGE: 'https://cdn.logitravel.com/comun/images/lineas/generica_1280x960.jpg'
};

//# sourceMappingURL=constants.js.map